import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CallbackResult, CallbackResultStatus, dateStringFromISO8601 } from '../../../../../../../utils';
import { CustomerChallenge } from '../../../../../../../models/challenge';
import { ChallengeService } from '../../../../../../../services/challenge/challenge.service';

@Component({
  selector: 'app-customer-challenge-modal',
  templateUrl: './customer-challenge-modal.component.html',
  styleUrls: ['./customer-challenge-modal.component.css']
})
export class CustomerChallengeModalComponent {

  @Input() customerChallenge: CustomerChallenge;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';
  public serverError: number = null;

  public inEditMode = false;

  public dateStringFromISO8601 = dateStringFromISO8601;

  constructor(
    public activeModal: NgbActiveModal,
    public challengeService: ChallengeService
  ) {}

  public handleSaveEdit() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.challengeService
      .updateCustomerChallenge(this.customerChallenge)
      .then(() => {
        this.savedCallback({
          text: 'Challenge updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit this challenge.';
        } else if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please fix the errors above and try again.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  public handleRemove() {
    if (!confirm('Are you sure you want to remove this customer from this challenge?')) {
      return;
    }

    this.loadingSubmit = true;

    this.errorMessage = '';

    this.challengeService
      .removeCustomerFromChallenge(
        this.customerChallenge.customer_id,
        this.customerChallenge.challenge_id
      )
      .then(() => {
        this.savedCallback({
          text: 'Customer removed from challenge.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove this customer from this challenge.';
        } else if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please fix the errors above and try again.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
